module.exports = __webpack_public_path__ + "images/sale_sticker@2x.png?ecb04350";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sale_sticker@2x.png
// module id = 693
// module chunks = 7